import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FiBookOpen, FiClock, FiUsers, FiBriefcase, FiUserCheck } from "react-icons/fi";
import "../about.css";

const stats = [
  { icon: <FiBookOpen />, value: "40+", label: "Programs" },
  { icon: <FiClock />, value: "16+", label: "Hours" },
  { icon: <FiUsers />, value: "55+", label: "Mentors" },
  { icon: <FiBriefcase />, value: "2K+", label: "Recruiters" },
  { icon: <FiUserCheck />, value: "18K+", label: "Students" },
];

export default function SuccessStats() {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="success-container">
      <h2 data-aos="fade-down" className="success-title">Success Stats</h2>
      <p data-aos="fade-up" className="success-subtitle">
     Numbers That Speak Louder Than Words
      </p>

      <div className="stats-grid">
        {stats.map((item, index) => (
          <div key={index} data-aos="zoom-in" className="stats-card">
            <div className="stats-icon">{item.icon}</div>
            <h3>{item.value}</h3>
            <p>{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
